export const PreInvestorConditionsTestIds = {
  // PreInvestorConditionsTable.js
  ADD_CONDITION_BUTTON: 'pre-investor-conditions.add-condition-button',
  BULK_PASTE_BUTTON: 'pre-investor-conditions.bulk-paste-button',

  // PreInvestorConditionDrawer.js
  DRAWER_SAVE_BUTTON: 'pre-investor-condition-drawer.save-button',

  // PreInvestorBulkPasteModal.js
  BULK_PASTE_INPUT: 'pre-investor-bulk-paste.conditions-input',
  BULK_PASTE_CANCEL_BUTTON: 'pre-investor-bulk-paste.cancel-button',
  BULK_PASTE_ADD_BUTTON: 'pre-investor-bulk-paste.add-button',
};
